import React from 'react';
import { MessageCircle, FileText, Phone, CheckCircle } from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      number: 1,
      icon: MessageCircle,
      title: 'Bedarf einschätzen',
      description: 'Überlegen Sie, welche Versicherungssumme für Sie sinnvoll ist und welche Wünsche Sie haben.'
    },
    {
      number: 2,
      icon: FileText,
      title: 'Angebot anfordern',
      description: 'Füllen Sie unser Formular aus oder kontaktieren Sie uns direkt für ein individuelles Angebot.'
    },
    {
      number: 3,
      icon: Phone,
      title: 'Persönliche Beratung',
      description: 'Wir besprechen gemeinsam Ihre Situation und finden die passende Absicherung für Sie.'
    },
    {
      number: 4,
      icon: CheckCircle,
      title: 'Absicherung abschließen',
      description: 'Nach Ihrer Zustimmung schließen wir die Versicherung ab – einfach und transparent.'
    }
  ];

  return (
    <section className="section section-beige">
      <div className="container-custom">
        <div className="section-header fade-in">
          <p className="section-accent">✦ DER PROZESS</p>
          <h2 className="headline-secondary">
            So einfach funktioniert es
          </h2>
          <p className="subheadline">
            In nur vier Schritten zur passenden Bestattungsvorsorge
          </p>
        </div>

        <div className="process-with-image">
          <div className="process-image-container fade-in">
            <img 
              src="/hands-image.png"
              alt="Generationen Hand in Hand - Fürsorge und Unterstützung"
              loading="lazy"
              className="process-image"
            />
          </div>

          <div className="process-steps">
            {steps.map((step, index) => {
              const IconComponent = step.icon;
              return (
                <div key={index} className="process-step fade-in" style={{ animationDelay: `${index * 0.15}s` }}>
                  <div className="step-number">{step.number}</div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
